import React, { useEffect, useState } from "react";
import { EmptyPage } from "../../../../components/EmptyPage";
import { PlusLg } from "react-bootstrap-icons";
import { ReactComponent as NoDataImage } from "./assets/noDataImage.svg";
import UsersList from "../../../../components/UserManagementComponents/Users/UsersList";
import { useSelector } from "react-redux";
import { getAllUsers } from "../../../../store/selectors/users";
import { requestAllUsers, setAllUsers } from "../../../../store/slices/users";
import { useDispatch } from "react-redux";
import { setActiveModal } from "../../../../store/slices/modals";
// import { getProfiles } from "../../../../store/selectors/profiles";

type Props = {};

export const UsersTable = (props: Props) => {
  const users = useSelector(getAllUsers);
  const dispatch = useDispatch();
  const [usersCount, setUsersCount] = useState(0);
  // const profile = useSelector(getProfiles);
  useEffect(() => {
    if (!users.length) {
      dispatch(requestAllUsers({
        limit: 20,
        callbacks: {
          onSuccess: (data) => {
            setUsersCount(data?.count || 0);
          }
        }
      }));
    }
    return () => {
      dispatch(setAllUsers([]));
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!users.length ? (
        <EmptyPage
          Icon={NoDataImage}
          title="No users were discovered"
          subTitle={`Feel free to invite new people into your space by clicking the "Invite People" button below! `}
          button={{
            name: "Invite People",
            onClick: () => {
              dispatch(setActiveModal({ id: "invitePeopleModal" }));
            },
            icon: <PlusLg />,
          }}
        />
      ) : (
        <>
          <UsersList users={users} usersCount={usersCount} />
        </>
      )}
    </>
  );
};
